module.exports = __webpack_public_path__ + "static/unternehmen-von-der-frage-bis-zur-loesung-img-45800b8ad271c309153672b53e55bd9c.jpg";